import { render, staticRenderFns } from "./AdviceOrderNew.vue?vue&type=template&id=0a1935e6&scoped=true&"
import script from "./AdviceOrderNew.vue?vue&type=script&lang=js&"
export * from "./AdviceOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./AdviceOrderNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdviceOrderNew.vue?vue&type=style&index=1&id=0a1935e6&scoped=true&lang=css&"
import style2 from "./AdviceOrderNew.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1935e6",
  null
  
)

export default component.exports